import React, {useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {useQueryWithStore} from 'react-admin';
import PayrollDeductionItem from './payrollDeductionItem';

const DeductionTypes = [
    {type: 'other', name: 'Other', cash: false},
    {type: 'damage', name: 'Damage', cash: true},
    {type: 'tax', name: 'Tax Paid on behalf', cash: true},
    {type: 'settelment', name: 'Cash Settlement', cash: true}
];

const BulkDeductionDialog = ({open, onClose, onSubmit, filteredPayroll}) => {
    const [deductions, setDeductions] = useState([]);
    const employeeCount = filteredPayroll.length;

    const {data: loanTemplates} = useQueryWithStore({
        type: 'getList',
        resource: 'loanTemplates',
        payload: {filter: {}, pagination: {}, sort: {}}
    });

    const handleSubmit = () => {
        const employeeIds = filteredPayroll.map(p => p.employeeId);
        onSubmit(deductions, employeeIds);
        onClose();
    };

    const handleDeductionChange = index => ot => {
        const newDeductions = deductions.slice(0);
        newDeductions[index] = ot;
        setDeductions(newDeductions);
    };

    const handleDeductionRemove = index => () => {
        const newDeductions = deductions.slice(0);
        newDeductions.splice(index, 1);
        setDeductions(newDeductions);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Bulk Deductions for {employeeCount} Employee{employeeCount !== 1 ? 's' : ''}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary" style={{marginBottom: 16}}>
                    These deductions will be applied to all {employeeCount} currently filtered employee{employeeCount !== 1 ? 's' : ''}.
                </Typography>

                <Card style={{marginBottom: 8}}>
                    <CardContent>
                        {deductions.map((ot, index) =>
                            <PayrollDeductionItem
                                loans={[]}
                                DeductionTypes={(loanTemplates ? loanTemplates.map(l => ({type: l.name, name: l.name})) : []).concat(DeductionTypes)}
                                key={index}
                                item={ot}
                                onRemove={handleDeductionRemove(index)}
                                onChange={handleDeductionChange(index)}
                            />
                        )}

                        <Button onClick={() => setDeductions([...deductions, {type: DeductionTypes[0].type, name: "Advance", value: 0, cash: true}])} color="primary">
                            Add
                        </Button>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="default">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={deductions.length === 0}
                >
                    Apply to {employeeCount} Employee{employeeCount !== 1 ? 's' : ''}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkDeductionDialog;
